import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Balance from '@/components_new/Balance.vue'
import BaseLink from '@/components_new/BaseLink.vue'
import Icon from '@/components_new/Icon/Icon.vue'
import Typography from '@/components_new/Typography.vue'
import UserAvatar from '@/components_new/UserAvatar.vue'
import { ROUTE_NAMES } from '@/router/constants'
import { User } from '@/types'


export default /*@__PURE__*/_defineComponent({
  __name: 'UserWidget',
  props: {
    user: {},
    userBalance: {},
    isProfilePage: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseLink, {
    class: _normalizeClass(_ctx.$style.profile),
    to: { name: _unref(ROUTE_NAMES).PROFILE },
    "data-interface-target": "profile-link"
  }, {
    default: _withCtx(() => [
      _createVNode(Icon, { name: "silver_fennec_coin_small" }),
      _createVNode(Typography, {
        type: "label",
        size: "l",
        class: _normalizeClass(_ctx.$style.balance),
        responsive: false
      }, {
        default: _withCtx(() => [
          _createVNode(Balance, {
            balance: props.userBalance
          }, null, 8, ["balance"])
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(UserAvatar, {
        class: _normalizeClass(_ctx.$style.avatar_override),
        avatar: props.user.avatar,
        firstName: props.user.firstName,
        lastName: props.user.lastName
      }, null, 8, ["class", "avatar", "firstName", "lastName"])
    ]),
    _: 1
  }, 8, ["class", "to"]))
}
}

})